<template>
  <div class="choose-area">
    <Cascader
      v-model="area"
      :placeholder="placeholder"
      :data="regionDataList"
      :style="`width: ${styleWidth}px`"
      @on-change="handelAreaChange"
    ></Cascader>
  </div>
</template>

<script>
import { regionDataList } from '@/utils/dictionary';
export default {
  props: {
    placeholder: {
      type: String,
      default: '所属行政区'
    },
    styleWidth: {
      type: [String, Number],
      default: 220
    }
  },
  data() {
    return {
      area: [],
      areaCode: [], // 所属行政区
      regionDataList: [...regionDataList]
    };
  },
  methods: {
    // 地区选择
    handelAreaChange(value, selectedData) {
      this.area = value;
      this.areaCode = value[value.length - 1];
      this.$emit('on-change', value);
    },
    // 清除
    handleClear() {
      this.area = [];
      this.areaCode = [];
    },
    // 获取选中的结果
    getResult() {
      return this.area;
    }
  }
};
</script>

<style>
</style>
